module.exports = __webpack_public_path__ + "img/userPhoto.6f6bbb16.png";